import React, { useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import Modal from "react-modal";
import { Button } from "@cxagroup/casper";
import { getBalanceDetails } from "../../../actions/claimActions";
import ArrowIcon from "../../../assets/images/svg/upper_arrow.svg";
import messages from "components/messagesDescription";
import { intlShape, injectIntl } from "react-intl";
import StandardMoney from "../../common/StandardMoney";

const colors = ["#f7f952", "#46a1fc", "#f7bf47"];

const SOAPopup = ({
  intl,
  isOpen,
  planYear,
  accountType,
  closePopup,
  getBalanceDetails,
  balanceDetails,
  currency,
}) => {
  useEffect(() => {
    getBalanceDetails(planYear, accountType);
  }, [planYear, accountType]);
  return (
    <Modal className="soa-popup" isOpen={isOpen}>
      <div className="soa-popup-container">
        <div style={{ textAlign: "left", margin: "10px" }}>
          <strong>
            {intl.formatMessage(messages.statementDateDescription)}: {moment(new Date()).format()}
          </strong>
        </div>
        {balanceDetails.length > 0 && (
          <div className="cal-container">
            {balanceDetails.map((element, index) => {
              return (
                <div key={element.name} className="cal-item-container">
                  <div
                    style={{
                      backgroundColor: colors[index],
                    }}
                    className="item"
                  >
                    <strong>{element.name}</strong>
                  </div>
                  <div
                    style={{
                      backgroundColor: colors[index],
                    }}
                    className="item item-one-row"
                  >
                    <strong>
                      <StandardMoney value={element.value} currency={currency} />
                    </strong>
                  </div>
                  <div className="item item-height">
                    <ArrowIcon style={{ width: "20px", height: "20px" }} />
                    <br />
                    <div dangerouslySetInnerHTML={{ __html: element.description }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Button
        style={{ width: "150px", marginTop: "20px", marginLeft: "auto", marginRight: "auto" }}
        onClick={closePopup}
      >
        {intl.formatMessage(messages.closeDescription)}
      </Button>
    </Modal>
  );
};

SOAPopup.propTypes = {
  isOpen: PropTypes.bool,
  planYear: PropTypes.string,
  accountType: PropTypes.string,
  closePopup: PropTypes.func.isRequired,
  getBalanceDetails: PropTypes.func.isRequired,
  balanceDetails: PropTypes.array,
  currency: PropTypes.string,
  intl: intlShape.isRequired,
};
const mapDispatchToProps = {
  getBalanceDetails,
};
const mapStateToProps = ({ claims }) => {
  return { balanceDetails: claims.balanceDetails };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SOAPopup));



// WEBPACK FOOTER //
// ./components/claim/widgets/SOAPopup.js